/* eslint-disable react/no-danger */
import { Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import TableOne from './Components/TableOne';
import TableThree from './Components/TableThree';
import TableTwo from './Components/TableTwo';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../../helper';
import { RootState } from '../../../../redux/rootState';

function ComponentJobOrder() {
  const { tableContent, reportPdfResponse1 } = useSelector((state:RootState) => state.reportPdfSliceReducer);

  return (
    <>
      <table className="w100">
        <tr>
          <td className="textLeft pt10 pb10" style={{ padding: '5px' }}>
            {ReportPart1(tableContent, CombineReportEnum.COMBINE_Job_Order, PDFReportEnum.PDF_Job_Order, 'Job Order')}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="textCenter underlineHeadingText">
            Job Order
          </td>
        </tr>
      </table>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12}>
          <TableThree />
        </Grid>
        <Grid item md={6} sm={12}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: '30px',
            justifyContent: 'center',
          }}
          >
            <TableOne />
            {reportPdfResponse1?.Ticklers_Data?.VesselInfo?.length > 0 && <TableTwo />}
          </div>
        </Grid>
        <Grid item md={6} sm={12}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '14px',
            marginTop: '20px',
          }}
          >
            Initial here when completed: ____________
          </div>
        </Grid>
      </Grid>
      <div className="page-break" />
      <table className="w100">
        <tr>
          <td className="textLeft pt10 pb10" style={{ padding: '5px' }}>
            {ReportPart1(tableContent, CombineReportEnum.COMBINE_Job_Order, PDFReportEnum.PDF_Job_Order, 'Job Order')}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="textCenter boldHeadingText">
            {`Job #: ${reportPdfResponse1?.Ticklers_Data?.JobOrder || ''}`}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="underlineHeadingText boldText pl30">
            Email Instructions:
          </td>
        </tr>
      </table>
      <div
        className="commonText mt20 customDataHtmlStyle p30 pt0"
        dangerouslySetInnerHTML={{ __html: reportPdfResponse1?.Ticklers_Data?.EmailInstructions || '' }}
      />
    </>
  );
}

export default ComponentJobOrder;
